module.exports = __webpack_public_path__ + "img/johan.e48d752d.png";